import React, { Component } from 'react';
import { connect } from "react-redux";
import { setInputField } from "../../../actions/fieldInputActions";
import { modalController } from "../../../actions/domActions";

require('./ModalListItem.scss');

function mapStateToProps (state, ownProps) {
    return {};
}

function mapDispatchToProps (dispatch, ownProps) {
    return {
        setInputField: (input, value) => dispatch(setInputField(input, value)),
        modalController: (currentModal) => dispatch(modalController(currentModal))
    };
}

class ActivityItem extends Component {
    render() {
        return (
            <div className="row activityItem">
                <div className="col-sm-3 col-xs-12 acvitiy-title">
                    <p className="itemId">{ this.props.category.name }</p>
                </div>
                <div className="col-sm-6 col-xs-12 activity-desc">
                    <p className="desc">{ this.props.category.desc }</p>
                </div>
                <div className="col-sm-3 col-xs-12 itemButton">
                    <button onClick={() => {
                            this.props.setInputField("CATEGORY", this.props.category);
                            this.props.modalController("CLOSE_ALL");
                        }}
                        className="btn-submit"
                        className={ this.props.buttonStyle }
                    >Select Activity</button>
                </div>
            </div>
        );
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(ActivityItem);



// WEBPACK FOOTER //
// ./app/components/Modals/ModalListItems/ActivityItem.jsx